<template>
  <TheLayout>
    <div v-if="dataPermission && dataPermission.includes('NSH_PARTNER_GROUP_CUS_VIEW')">
      <div class="row">
        <div class="col-12">
        <div
          class="
          page-title-box
          d-flex
          align-items-center
          justify-content-between
          "
        >
          <b class="fs-16 text-bold">KHÁCH HÀNG</b>
        </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <a href="javascript:void(0)" class="linkItemTab" @click="$router.push(`/customer-list`)">Danh sách khách hàng</a>
          <span class="seperate"> | </span> 
          <a href="javascript:void(0)" class="linkItemTab active" @click="$router.push(`/group-customer`)">Nhóm khách hàng</a>
        </div>
      </div>

      <div v-if="isShow">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="row mb-3">
                  <div class="col-lg-6">
                    <b-input-group class="wrapperInput">
                      <b-input-group-prepend>
                        <span class="input-group-text"><img src="@/assets/images/icon-search-box.svg"></span>
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="filter"
                        @change="searchData"
                        class="form-control f12 hc-37 textNameSearch"
                        placeholder="Tìm kiếm theo tên nhóm">
                      </b-form-input>
                      <div
                        v-if="this.filter != ''"
                        class="removeText text-danger"
                        @click="remove()">×
                      </div>
                    </b-input-group>
                  </div>
                  <div class="col-lg-6">
                    <b-button
                      v-if="dataPermission && dataPermission.includes('NSH_PARTNER_GROUP_CUS_CREATE')"
                      variant="primary"
                      class="float-right"
                      @click="addItem(selected)">
                      <i class="bx bx-plus font-size-16 align-middle mr-2"></i>Thêm nhóm KH
                    </b-button>
                  </div>
                </div>
                <div class="row mb-2" v-if="(selected.length > 0)">
                  <div class="col-md-12">
                    <span class="mt-2 d-inline mr-2">Đã chọn {{selected.length}} nhóm khách hàng</span>
                    <b-button
                      variant="danger"
                      class="btn-xs btn-danger-ext"
                      @click="deleteItem(selected)"
                      v-if="dataPermission && dataPermission.includes('NSH_PARTNER_GROUP_CUS_DELETE')">Xóa nhóm khách hàng
                    </b-button>
                  </div>
                </div>
                <div class="table-responsive mb-0">
                  <b-table
                    head-variant="light"
                    hover
                    :items="dataGroups"
                    :fields="fields"
                    tbody-tr-class="row-table-class">

                    <template #table-caption>
                      <div v-if="dataGroups.length == 0" class="emptyData">
                        <p>Danh sách của bạn chưa có liên hệ nào</p>
                      </div>
                    </template>

                    <template v-slot:head(selected)="data">
                      <BaseCheckbox
                        v-model="selectAll"
                        :value="data.item"
                      />
                    </template>

                    <template #cell(selected)="data">
                      <b-form-group style="margin-bottom: 0px">
                        <b-form-checkbox
                          v-if="!data.item.defaultGroup"
                          v-model="selected"
                          :value="data.item"/>
                      </b-form-group>
                    </template>

                    <template #cell(name)="data">
                      <p v-if="!data.item.defaultGroup && dataPermission && dataPermission.includes('NSH_PARTNER_GROUP_CUS_UPDATE')" style="margin: 0px; white-space: nowrap" class="text-primary d-inline"
                        @click="editItem(data.item)">{{ data.item.name }}
                      </p>
                      <p v-else style="margin: 0px; white-space: nowrap">
                        {{ data.item.name }}
                      </p>
                    </template>

                    <template #cell(descriptions)="data">
                      <p style="margin: 0px" class="text">
                        {{ data.item.description }}
                      </p>
                    </template>

                    <template #cell(totalPartner)="data">
                      <p style="margin: 0px; width:45%;margin-right:3%" class="text text-right">
                        {{ data.item.totalPartner }}
                      </p>
                    </template>

                    <template #cell(createdAt)="data">
                      {{ data.item.createdAt | formatDate}}
                    </template>
                    
                  </b-table>
                </div>
              </div>
              <div class="row d-flex justify-content-end mr-3">
                <div class="order-list-nav order-list-footer d-flex justify-content-end">
                  <b-pagination @change="changeCurrentPage" v-model="currentPage" :total-rows="totalElements" :per-page="search.limit" aria-controls="debt-table" hide-goto-end-buttons limit="5" last-text="next" align="right" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-loading" v-if="loading">
        <div class="loading">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
      </div>

     

      <el-dialog title="Thêm/sửa nhóm KH" v-if="modalNewGroup" :visible.sync="modalNewGroup" id="modalRemove" width="500px"
			@close="modalNewGroup=false">
        <div slot="title">
          <div v-if="adding" class="text-title-modal">Thêm mới nhóm KH</div>
          <div v-else class="text-title-modal">Sửa thông tin nhóm KH</div>
        </div>
        <validation-observer ref="observerPartner" v-slot="{ validate }">
          <div class="line padd15">
              <RowWrapper>
                <template #center>
                  <RowWrapper>
                    <template #center>
                      <b-form-group label="" label-for="formrow-groupname-input">
                        <validation-provider
                          name="Tên nhóm"
                          rules="required|lBetween:1,255|CHECK_HTML"
                          v-slot="{ errors, valid }">
                          <label>Tên nhóm<sup class="text-danger"> * </sup></label>
                          <b-form-input
                            id="formrow-groupname-input"
                            type="text"
                            placeholder="Nhập tên nhóm"
                            v-model="dataGroup.name"
                            :state="errors[0] ? false : valid ? true : null"
                            @keydown.enter.prevent
                          />
                          <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </validation-provider>
                      </b-form-group>
                    </template>
                  </RowWrapper>

                  <RowWrapper>
                    <template #center>
                      <b-form-group label="" label-for="formrow-description-input">
                        <validation-provider
                          name="Mô tả"
                          rules="lBetween:1,500|CHECK_HTML"
                          v-slot="{ errors, valid }">
                          <label>Mô tả</label>
                          <b-form-textarea
                            v-model.trim="dataGroup.description"
                            id="formrow-description-input"
                            class="form-control"
                            name="textarea"
                            rows="3"
                            placeholder="Nhập mô tả"
                            :state="errors[0] ? false : valid && dataGroup.description != null && dataGroup.description != '' ? true : null"
                          />
                          <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </validation-provider>
                      </b-form-group>
                    </template>
                  </RowWrapper>
                </template>
              </RowWrapper>
          </div>
          <div class="line mt-2 bdt-btn-action">
            <div class="padd5" v-if="adding">
              <button class="btn btn-primary pull-right" @click.prevent="saveItem(validate)">Hoàn tất</button>
              <button type="button" class="btn btn-default-ext text-primary pull-right" @click="modalNewGroup=false">Thoát</button>
            </div>
            <div class="padd5" v-else>
                <button v-if="dataPermission && dataPermission.includes('NSH_PARTNER_GROUP_CUS_DELETE')" class="btn btn-danger-ext" @click="deleteItem(dataGroup)">Xóa</button>
                <button class="btn btn-primary pull-right" @click.prevent="saveItem(validate)">Lưu thay đổi</button>
                <button class="btn btn-default btn-default-ext pull-right" @click="destroyModal()">Thoát</button>
            </div>
          </div>
      </validation-observer>
		</el-dialog>

      <!--Xóa Item-->
		<el-dialog title="Xoá nhóm khách hàng" v-if="modalRemove" :visible.sync="modalRemove" id="modalRemove" width="500px"
			@close="modalRemove=false">
			<div class="line text-center">
				<div class="mt-2">
				<img src="@/assets/images/customer-nope-1.svg" />
				</div>
				<div class="mt-2">
					Bạn chắc chắn muốn xoá các nhóm khách hàng đã chọn ?<br/>
          Thao tác này không thể khôi phục.
				</div>
			</div>
			<div class="line mt-4 bdt-btn-action">
				<div class="padd5">
					<button @click="confirmRemove" type="button" class="btn btn-default btn-default-red pull-right">Xác nhận xoá</button>  
					<button type="button" class="btn btn-default-ext text-primary pull-right" @click="modalRemove=false">Thoát</button>
				</div>
			</div>
		</el-dialog>
    </div>
    <NotPermission v-else></NotPermission>
  </TheLayout>
</template>
<script>
import Swal from "sweetalert2";
import RowWrapper from "@/components/wrappers/RowWrapper";
import { CustomerServices } from "@/services/nextshop/customer.service";

export default {
  components: {
    RowWrapper
  },
  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
      isShow: false,
      loading: false,
      fields: [
      {
          key: "selected",
          label: "",
          thStyle: { width: "1%" },
        },
        {
          key: "name",
          label: "Tên nhóm",
          thStyle: { width: "20%" },
        },
        {
          key: "descriptions",
          label: "Mô tả",
          thStyle: { width: "20%" },
        },
        {
          key: "totalPartner",
          label: "SL khách hàng",
          thStyle: { width: "10%" },
        },
        {
          key: "createdAt",
          label: "Ngày tạo",
          thStyle: { width: "10%" },
        }
      ],
      dataGroups: [],
      selected: [],
      modalNewGroup: false,
      textSearch: "",
      perPage: 10,
      adding: true,
      dataGroup: {},

      search: {
        query: "",
        merchantId: JSON.parse(localStorage.getItem("auth.currentUser")).merchantId,
        sort: "date",
        page: 1,
        limit: 30
      },
      currentPage: 1,
      totalElements: 0,
      filter: '',
      modalRemove:false,
      dataRemove: {}
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const response = await CustomerServices.getGroupCustomer(this.search);
        if (response.success) {
          this.dataGroups = response.data.data;
          this.totalElements = response.data.totalElements;
        }
        this.selected = [];
        this.loading = false;
      } catch (error) {
        console.log(error);
      } finally {
        this.isShow = true
        this.loading = false;
      }
    },
    addItem() {
      this.adding = true;
      this.dataGroup = {};
      this.modalNewGroup = true;
    },
    editItem(data) {
      if (data.defaultGroup) {
        Swal.fire("Không thể sửa", "Nhóm khách hàng mặc định!", "error");
      } else {
        this.adding = false;
        this.dataGroup = {
          id: data.id,
          name: data.name,
          description: data.description,
          version: data.version,
        };
        this.modalNewGroup = true;
      }
    },
    async deleteItem(data) {
      this.modalRemove = true
      this.dataRemove = data
    },
    async confirmRemove(){
      await this.deleteGroups(this.dataRemove);
    },
    destroyModal() {
      this.modalNewGroup = false;
    },
    async saveItem(validate) {
      validate().then(async (success) => {
        if (!success) {
          const el = document.querySelector(".is-invalid");
          el.focus();
          return;
        }
        this.loading = true;
        try {
          const params = {
            merchantId: this.inforAccount.merchantId,
            id: this.dataGroup.id,
            name: this.dataGroup.name,
            description: this.dataGroup.description
              ? this.dataGroup.description
              : null,
          };

          if (this.adding) {
            params.defaultGroup = false;
            const response = await CustomerServices.createGroup(params);

            if (response.success) {
              this.destroyModal();
              this.successmsg();
            }
          } else {
            params.version = this.dataGroup.version;
            const response = await CustomerServices.editGroup(params);
            if (response.success) {
              this.destroyModal();
              this.successmsg();
            }
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      });
    },
    async deleteGroups(data) {
      this.loading = true;
      this.modalRemove = false
      const params =
        data.length > 1
          ? data.map((e) => {
              return e.id;
            })
          : [data.id];

      try {
        const response = await CustomerServices.deleteGroup({
          merchantId: this.inforAccount.merchantId,
          groupIds: params,
        });
        if (response.success) {
          this.fetchData();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    successmsg() {
      this.fetchData();
    },
    
    changeCurrentPage(page) {
      this.currentPage = page
      this.search.page = page;
      this.fetchData();
    },
    searchData() {
      this.search.name = this.filter;
      this.fetchData();
    },
    remove() {
      this.filter = "";
      this.fetchData();
    }
  },
  computed: {
    selectAll: {
      get: function () {
        const dataSelect = this.dataGroups.find(e => e.defaultGroup === false)
        if ((dataSelect) && this.selected.length ===  dataSelect.length) {
          return "TRUE"
        } else if (this.selected.length === 0) {
          return "FALSE"
        } else {
          return "ORTHER"
        }
      },
      set: function (value) {
        var selected = []
        if (value) {
          this.dataGroups.forEach(function (item) {
            if(!item.defaultGroup){
              selected.push(item)
            }
          })
        }
        this.selected = selected
      },
    },
    rows() {
      return this.dataGroups.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.linkItemTab{
  font-weight: bold;
  color: #808890;
  font-size: 18px;
}
.linkItemTab.active{
  font-weight: bold;
  color: #23313E;
}
.seperate{
  color: #808890;
  padding: 0 10px;
}
.btn-default{
  background: #F2F3F4!important;
}
.btn-danger-ext{
  background: #FEF3F5!important;
  border-color: #FEF3F5!important;
  color: #DC2323!important;
}
.padding-ext {
  padding: 10px!important;
}
.btn.btn-filter {
  background: #eff2f7 !important;
  border: 1px solid #eff2f7;
  color: #23313E !important;
  width: 100%;
  display: inline-block;
  padding: 5px 10px!important;
}
.__checkbox{
  display: inline-block;
}
.table td {
  padding: 15px 0.75rem 15px!important;
}
.btn-default-ext{
  background: none!important;
  color: #3E69F6!important;
}
::v-deep #modalRemove .el-dialog__body {
  padding: 20px 0px 15px;
  display: inline-block;
  width: 100%;
}
.padd15{
  padding: 0 15px;
}
::v-deep .el-dialog__header {
  padding: 14px;
}
.input-group-text{
  background: none!important;
}
.wrapperInput .form-control {
  border-left: none!important;
  padding-left: 0!important;
}
.btn-default-red{
  background: #FEF3F5 !important;
  border-color: #FEF3F5 !important;
  color: #DC2323 !important;
}
</style>


